var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinSquare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.429 0H1.567C.702 0 0 .712 0 1.586v18.828C0 21.288.702 22 1.567 22h18.862c.864 0 1.571-.712 1.571-1.586V1.586C22 .712 21.293 0 20.429 0zM6.649 18.857H3.39V8.358h3.265v10.5H6.65zM5.02 6.924a1.891 1.891 0 010-3.781c1.04 0 1.89.85 1.89 1.89a1.888 1.888 0 01-1.89 1.891zm13.853 11.933h-3.26V13.75c0-1.218-.025-2.784-1.695-2.784-1.7 0-1.96 1.326-1.96 2.696v5.195h-3.26V8.358h3.128v1.434h.044c.437-.825 1.503-1.694 3.089-1.694 3.3 0 3.914 2.175 3.914 5.004v5.755z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSquare);
export default __webpack_public_path__ + "static/media/linkedin-square.8e808957.svg";
export { ForwardRef as ReactComponent };